export const MASTER_SOURCE_OPTIONS = ['Events', 'Social', 'Advertising', 'Direct', 'Media', 'Outbound'].map(name => ({ key: name, value: name, text: name }));
